import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  container: {
    padding: '0 0 0 58px'
  },
  divider: {
    padding: '10px 0',
  },
  content: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '24px',
    letterSpacing: 0.4,
    display: 'flex',
    justifyContent: 'space-between',
    gap: 10
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'underline'
  },
}))
